// @flow

import { RECEIVED_SOCIAL_SETTINGS, RECEIVED_SOCIAL_LABEL_SETTINGS } from './constants';
import type { SocialSettings } from './types';

export type ReceivedSocialSettings = {|
  type: typeof RECEIVED_SOCIAL_SETTINGS,
  payload: SocialSettings,
|};

export type ReceivedSocialLabelSettings = {|
  type: typeof RECEIVED_SOCIAL_LABEL_SETTINGS,
  label: string,
  payload: SocialSettings,
|};

type RSLS = ReceivedSocialLabelSettings; // renamed type for sake of line length

export const receivedSocialSettings = (data: SocialSettings): ReceivedSocialSettings => ({
  type: RECEIVED_SOCIAL_SETTINGS,
  payload: data,
});

export const receivedSocialLabelSettings = (label: string, payload: SocialSettings): RSLS => ({
  type: RECEIVED_SOCIAL_LABEL_SETTINGS,
  label,
  payload,
});

export default null;
